































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import type { FilterCheckboxOptionType } from '../atoms/ExpandableList.vue';
import type { FilterRadioOptionType } from '../atoms/RadioComponent/RadioContainer.vue';

type SearchFilterVariant = 'checkbox' | 'radio';

export default defineComponent({
  name: 'SearchFilter',
  props: {
    variant: {
      type: String as PropType<SearchFilterVariant>,
      required: true
    },
    threshold: {
      type: Number
    },
    title: {
      type: Object,
      default() {
        return {
          name: 'Title',
          explanation: ''
        };
      }
    },
    items: {
      type: Array as PropType<
        FilterCheckboxOptionType[] | FilterRadioOptionType[]
      >,
      required: true
    },
    selected: {
      type: Object as PropType<FilterRadioOptionType>
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    isFirstTwentyItems() {
      return this.index <= 20;
    },
    sortedItems() {
      return this.items.filter(
        // if number_of_products is null, item should still be included
        (item: FilterCheckboxOptionType) => item.number_of_products !== 0
      );
    }
  },
  methods: {
    updateOption(value) {
      this.$emit('onUpdate', value);
    }
  }
});
